import React from 'react'
import { Link } from 'react-router-dom'

// Components
import GlobalStyles from '../../../../components/component-items/styles'
import { StatusBoxStyled } from '../../../../components/component-items/status-box'
import { TableCell } from '../../../../components/component-items/datatable'
import { TableRow, SummaryLine } from '../styles'

// Types
import type { LogisticUnit } from '../types'
import { STATE_COLOR_MAP, STATE_DISPLAY_MAP } from '../types'

type ChildrenTabProps = {
  children: LogisticUnit[]
}

export const ChildrenTab = ({ children }: ChildrenTabProps) => {
  return (
    <div>
      <SummaryLine>
        {children.length} nested container{children.length !== 1 ? 's' : ''}
      </SummaryLine>
      {children.length > 0 ? (
        <GlobalStyles.DataTable>
          <thead>
            <tr>
              <th>
                <span className="text">LPN</span>
              </th>
              <th>
                <span className="text center">Type</span>
              </th>
              <th>
                <span className="text center">Contents</span>
              </th>
              <th>
                <span className="text center">State</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {children.map((child: LogisticUnit) => (
              <TableRow key={child.lpn}>
                <TableCell input={<Link to={`/inventory/container/${child.lpn}/`}>{child.lpn}</Link>} />
                <TableCell center input={child.container_type_name || '\u2014'} />
                <TableCell center input={`${child.total_quantity} units`} />
                <TableCell center>
                  <StatusBoxStyled
                    className={STATE_COLOR_MAP[child.state] || 'silver'}
                    style={{ width: 100, margin: '0.5em auto' }}
                  >
                    {STATE_DISPLAY_MAP[child.state] || child.state}
                  </StatusBoxStyled>
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </GlobalStyles.DataTable>
      ) : (
        <p style={{ color: '#74788d', fontStyle: 'italic' }}>No nested containers.</p>
      )}
    </div>
  )
}

export default ChildrenTab
